export default __webpack_public_path__ + "static/media/gallery_16.c28e480a.jpg";